<template>
  <div
    class="property-listing list_view style_new"
    :class="border ? 'border rounded' : ''"
  >
    <div class="listing-img-wrapper position-relative">
      <!-- <div class="like_unlike_prt">
        <label class="toggler toggler-danger"
          ><input type="checkbox" /><i class="fa fa-heart"></i
        ></label>
      </div> -->
      <!-- <div class="position-absolute top-0 left-0 ms-3 mt-3 z-1">
        <div
          v-for="(tag, index) in item.tag"
          :key="index"
          class="label bg-success text-light d-inline-flex align-items-center justify-content-center me-1"
          :class="{
            'bg-success': tag === 'Verified',
            'bg-purple': tag === 'SuperAgent',
            'bg-danger': tag === 'New',
          }"
        >
          <img v-if="tag === 'Verified'" :src="verified" alt="" class="me-1" />
          <img v-if="tag === 'SuperAgent'" :src="user1" alt="" class="me-1" />
          <img v-if="tag === 'New'" :src="moon" alt="" class="me-1" />
          {{ tag }}
        </div>
      </div> -->
      <div
        v-if="item.propertyClosed"
        class="position-absolute ms-3 mt-3 z-1"
        style="
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 70%;
        "
      >
        <div
          v-for="(tag, index) in item.tag"
          :key="index"
          class="label rentedclass bg-danger text-light d-inline-flex align-items-center justify-content-center me-1"
        >
          {{ item.tag2 === "For Rent" ? "Rented" : "Sold" }}
        </div>
      </div>
      <div class="list-img-slide">
        <div class="clior">
          <div v-for="(el, index) in item.image" :key="index">
            <div v-if="!item.propertyClosed">
              <router-link :to="`/single-property-1/${item.id}`"
                ><img :src="el" class="img-fluid" alt=""
              /></router-link>
            </div>
            <div v-else>
              <img :src="el" class="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list_view_flex">
      <div class="listing-detail-wrapper mt-1">
        <div class="listing-short-detail-wrap">
          <div class="_card_list_flex mb-2">
            <div class="_card_flex_01 d-flex align-items-center">
              <span
                v-if="item.tag2 === 'For Rent'"
                class="label bg-light-success text-success prt-type me-2"
                >For Rent</span
              >
              <span
                v-if="item.tag2 === 'For Sell'"
                class="label bg-light-danger text-danger prt-type me-2"
                >For Sell</span
              >
              <span class="label bg-light-purple text-purple property-cats">{{
                item.type
              }}</span>
            </div>
            <div class="_card_flex_last">
              <h6 class="listing-info-price text-primary fs-4 mb-0">
                $ {{ item.propertyValue }}
              </h6>
            </div>
          </div>
          <div class="_card_list_flex">
            <div class="_card_flex_01">
              <h4 class="listing-name mt-3">
                <router-link
                  :to="`/single-property-1/${item.id}`"
                  class="prt-link-detail"
                  >{{ item.loction }}</router-link
                >
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="price-features-wrapper">
        <div
          class="list-fx-features d-flex align-items-center justify-content-between"
        >
          <div class="listing-card d-flex align-items-center">
            <div class="square--30 text-muted-2 fs-sm circle gray-simple me-2">
              <i class="fa-solid fa-shower fs-sm"></i>
            </div>
            <span class="text-muted-2">{{ item.washrooms }}</span>
          </div>
          <div class="listing-card d-flex align-items-center">
            <div class="square--30 text-muted-2 fs-sm circle gray-simple me-2">
              <i class="fa-solid fa-bed fs-sm"></i>
            </div>
            <span class="text-muted-2">{{ item.beds }}</span>
          </div>
          <div class="listing-card d-flex align-items-center">
            <div class="square--30 text-muted-2 fs-sm circle gray-simple me-2">
              <i class="fa-solid fa-clone fs-sm"></i>
            </div>
            <span class="text-muted-2">{{ item.sqft }}</span>
          </div>
        </div>
      </div>
      <div class="listing-detail-footer mt-2 d-flex">
        <div class="listing-card d-flex availability-highlight">
          <div class="square--25 text-muted-2 fs-sm circle gray-simple me-1">
            <i class="fa-solid fa-calendar-week fs-xs"></i>
          </div>
          <span class="text-primary fw-semibold mx-2">Availability: </span>
          <span class="fw-semibold">{{ item.availableDate }}</span>
        </div>
      </div>
      <div
        class="listing-detail-footer mt-2 d-flex align-items-center justify-content-between"
      >
        <div class="footer-first">
          <div class="listing-features-info">
            <ul class="featur_5269">
              <!-- <li>
                <span class="text-muted-2">{{ item.type }}</span>
              </li> -->
              <!-- <li>
                <div class="ft_th">
                  <i class="fa-solid fa-snowflake text-muted-2"></i>
                </div>
              </li>
              <li>
                <div class="ft_th">
                  <i class="fa-solid fa-wifi text-muted-2"></i>
                </div>
              </li>
              <li>
                <div class="ft_th">
                  <i class="fa-solid fa-dumbbell text-muted-2"></i>
                </div>
              </li>
              <li>
                <div class="ft_th">
                  <i class="fa-solid fa-car text-muted-2"></i>
                </div>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer-flex">
          <router-link
            to="#"
            data-bs-toggle="modal"
            :data-bs-target="`#availability-${item.id}`"
            class="btn btn-md btn-primary fw-medium"
            data-bs-placement="top"
            data-bs-title="Check Availability"
          >
            <span class="svg-icon text-light svg-icon-2hx me-1">
              <svg
                width="19"
                height="19"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.3"
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                  rx="10"
                  fill="currentColor"
                />
                <path
                  d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
                  fill="currentColor"
                />
              </svg> </span
            >Book Showing
          </router-link>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      :id="`availability-${item.id}`"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sign-up"
      aria-hidden="true"
      ref="modalRef"
    >
      <div
        class="modal-dialog modal-dialog-centered login-pop-form"
        role="document"
      >
        <div class="modal-content" id="sign-up">
          <span class="mod-close" data-bs-dismiss="modal" aria-hidden="true"
            ><i class="fa-solid fa-circle-xmark text-muted-2 fs-5"></i
          ></span>
          <div class="modal-body">
            <div class="text-center">
              <h2 class="mb-0">CONTACT</h2>
              <h4 class="my-2">{{ item.loction }}</h4>
              <!-- Use a standard <a> tag for tel: links -->
              <a class="_calss_tyui theme-cl" href="tel:5068897999"
                >(506) 889-7999</a
              >
            </div>
            <div class="login-form mt-2">
              <form @submit.prevent="sendMessage">
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <label class="mb-1">Message</label>
                      <textarea
                        class="form-control ht-120"
                        v-model="message"
                        :placeholder="`I am interested in this property ${item.loction}. Please send me current availability and additional details`"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <label class="mb-1">Name*</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="name"
                        :class="{ 'is-invalid': errors.name }"
                      />
                      <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <label class="mb-1">Email*</label>
                      <input
                        type="email"
                        class="form-control"
                        v-model="email"
                        :class="{ 'is-invalid': errors.email }"
                      />
                      <div v-if="errors.email" class="invalid-feedback">
                        {{ errors.email }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <label class="mb-1">Phone*</label>
                      <input
                        type="tel"
                        class="form-control"
                        :value="phone"
                        @input="formatPhoneNumber"
                        :class="{ 'is-invalid': errors.phone }"
                        maxlength="15"
                      />
                      <div v-if="errors.phone" class="invalid-feedback">
                        {{ errors.phone }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="default-terms_wrap">
                  <div class="default-terms_flex">
                    <input
                      :id="`tm-${item.id}`"
                      class="form-check-input"
                      name="tm"
                      type="checkbox"
                      v-model="gdprAgreement"
                      :class="{ 'is-invalid': errors.gdpr }"
                    />
                    <label
                      :for="`tm-${item.id}`"
                      class="form-check-label"
                    ></label>
                  </div>
                  <div class="default-terms">
                    I consent to having this website store my submitted
                    information so they can respond to my inquiry.
                  </div>
                </div>
                <div v-if="errors.gdpr" class="invalid-feedback d-block">
                  {{ errors.gdpr }}
                </div>

                <div class="form-group mt-3">
                  <button
                    type="submit"
                    class="btn btn-primary full-width fw-medium"
                    :disabled="isSending"
                  >
                    <span
                      v-if="isSending"
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {{ isSending ? "Sending..." : "Send Message" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref, nextTick } from "vue";
import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal } from "bootstrap"; // Import Bootstrap's Modal API
import Swal from "sweetalert2"; // 1. Import SweetAlert2
import "sweetalert2/dist/sweetalert2.min.css"; // 2. Import the CSS

const prop = defineProps({
  item: Object,
  border: String,
});

const initialized = ref(false);

// Form inputs
const email = ref("");
const phone = ref("");
const name = ref("");
const message = ref("");
const gdprAgreement = ref(false);
// Reference to the modal
const modalRef = ref(null);
const errors = ref({}); // 3. Add ref for inline errors
const isSending = ref(false);

// 1. Add this function to filter input
const formatPhoneNumber = (event) => {
  // Replace any character that is not a digit with an empty string
  const formatted = event.target.value.replace(/[^0-9]/g, "");
  phone.value = formatted;
};

const initializeSlickSlider = () => {
  nextTick(() => {
    const slider = $(".clior");
    try {
      if (slider.length > 0) {
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
        slider.slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        });
      } else {
        console.error("Slick Slider element not found!");
      }
    } catch (error) {
      console.error("Error initializing Slick Slider:", error);
    }
  });
};

onMounted(() => {
  if (!initialized.value) {
    initialized.value = true;
    initializeSlickSlider();
  }
  // console.log("item:", prop.item);
});

// Method to send a message
const sendMessage = async () => {
  errors.value = {};
  if (!name.value.trim()) errors.value.name = "Name is required.";
  if (!email.value.trim()) errors.value.email = "Email is required.";
  else if (!/^\S+@\S+\.\S+$/.test(email.value))
    errors.value.email = "Please enter a valid email address.";
  // 2. Update phone validation
  if (!phone.value.trim()) {
    errors.value.phone = "Phone number is required.";
  } else if (phone.value.length < 10) {
    errors.value.phone =
      "Please enter a valid phone number (at least 10 digits).";
  }
  if (!gdprAgreement.value)
    errors.value.gdpr = "You must consent to the terms.";

  if (Object.keys(errors.value).length > 0) {
    return; // Stop if validation fails
  }

  isSending.value = true;
  try {
    // Fill the placeholder message if the message field is empty
    if (!message.value.trim()) {
      message.value = `I am interested in this property ${prop.item.loction}. Please send me current availability and additional details.`;
    }

    const requestBody = {
      email: email.value,
      phone: phone.value,
      description: message.value,
      name: name.value,
      address: prop.item.loction,
    };
    console.log("Sending message with data:", requestBody);

    const response = await fetch(process.env.VUE_APP_sendEmailURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    // Close the modal
    const modalInstance = Modal.getInstance(modalRef.value);
    if (modalInstance) {
      modalInstance.hide();
    }

    console.log("Message sent successfully:");
    // 6. Show SweetAlert success modal
    Swal.fire({
      title: "Success!",
      text: "Your message has been sent successfully.",
      icon: "success",
      confirmButtonText: "OK",
    });

    // Use a timeout to ensure cleanup happens after Bootstrap's internal operations
    setTimeout(() => {
      // Ensure the `modal-open` class is removed from the body
      document.body.classList.remove("modal-open");

      // Remove any remaining modal backdrop
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((backdrop) => backdrop.remove());

      // Reset the body's `style` attribute
      document.body.removeAttribute("style");
    }, 500); // 100ms timeout

    // Reset form fields
    email.value = "";
    phone.value = "";
    message.value = "";
    name.value = "";
    gdprAgreement.value = false; // Reset GDPR agreement checkbox
  } catch (error) {
    console.error("Error sending message:", error);
    // 7. Show SweetAlert error modal
    Swal.fire({
      title: "Error!",
      text: "Failed to send the message. Please try again.",
      icon: "error",
      confirmButtonText: "OK",
    });
  } finally {
    isSending.value = false; // 8. Reset sending state
  }
};
</script>
<style scoped>
.availability-highlight {
  background: #eaf4fb;
  border-radius: 8px;
  color: #009868;
}
</style>
